import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, BookOpenIcon, NewspaperIcon, GlobeIcon } from 'lucide-react';
import { ThreeDBackground } from './ThreeDBackground';
export function Recognition() {
  const highlights = [{
    text: 'Internationally recognized pioneer in osseointegration, bone grafting, and implant reconstruction',
    icon: <AwardIcon size={32} className="text-gold" data-id="element-270" />
  }, {
    text: 'Author of 100+ peer-reviewed scientific publications & multiple landmark textbooks',
    icon: <BookOpenIcon size={32} className="text-gold" data-id="element-271" />
  }, {
    text: 'Editor and editorial board member for leading global medical and dental journals',
    icon: <NewspaperIcon size={32} className="text-gold" data-id="element-272" />
  }, {
    text: 'Frequent global keynote speaker across North America, Europe, Asia, and the Middle East',
    icon: <GlobeIcon size={32} className="text-gold" data-id="element-273" />
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="recognition" className="py-24 md:py-32 bg-gradient-navy relative overflow-hidden" data-id="element-274">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold via-transparent to-transparent pointer-events-none" data-id="element-275"></div>

      {/* 3D Animated Background */}
      <ThreeDBackground variant="subtle" data-id="element-276" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-277">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center flex flex-col items-center" data-id="element-278">
          <div className="w-16 h-px bg-gold mb-6" data-id="element-279"></div>
          <h2 className="font-sans text-gold text-sm uppercase tracking-widest font-medium mb-4" data-id="element-280">
            Global Recognition
          </h2>
          <h3 className="font-serif text-4xl md:text-5xl text-white font-medium leading-tight" data-id="element-281">
            Pioneering Voice in Implantology
          </h3>
        </motion.div>

        {/* Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-282">
          {highlights.map((item, index) => <motion.div key={index} variants={itemVariants} className="relative bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-10 flex flex-col sm:flex-row items-start sm:items-center gap-6 group hover:bg-white/10 transition-colors duration-300" data-id="element-283">
              {/* Mini Gold Corners */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-gold/60" data-id="element-284"></div>
              <div className="absolute top-0 right-0 w-4 h-4 border-t border-r border-gold/60" data-id="element-285"></div>
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b border-l border-gold/60" data-id="element-286"></div>
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-gold/60" data-id="element-287"></div>

              <div className="flex-shrink-0 p-4 bg-navy-rich rounded-sm border border-gold/20 group-hover:border-gold/50 transition-colors" data-id="element-288">
                {item.icon}
              </div>
              <p className="font-serif text-xl md:text-2xl text-white/90 leading-snug" data-id="element-289">
                {item.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}